import { motion } from 'framer-motion'
import { usePageTransition } from '@/context/PageTransitionContext'

export function PageTransitionOverlay() {
  const { phase } = usePageTransition()
  const isOpaque = phase === 'covering' || phase === 'covered'

  return (
    <motion.div
      aria-hidden
      className="bg-background"
      animate={{ opacity: isOpaque ? 1 : 0 }}
      transition={{ duration: 0.22 }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 49,
        pointerEvents: phase !== 'idle' ? 'auto' : 'none',
      }}
    />
  )
}
